module.exports = __webpack_public_path__ + "static/home-page-bg-3c7c2a38e275a163ba29fa81d66272df.png";